module.exports = __webpack_public_path__ + "img/arbre_fleuri.a1298012.jpg";